import React from 'react'
import {Icon} from '@chakra-ui/react'

const AccountIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props}>
            <g clipPath="url(#clip0_31_627)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.0016 3.12499C16.2047 3.12499 13.1266 6.20304 13.1266 10C13.1266 13.797 16.2047 16.875 20.0016 16.875C23.7986 16.875 26.8766 13.797 26.8766 10C26.8766 6.20304 23.7986 3.12499 20.0016 3.12499ZM10.21 10C10.21 4.59221 14.5938 0.208328 20.0016 0.208328C25.4094 0.208328 29.7933 4.59221 29.7933 10C29.7933 15.4078 25.4094 19.7917 20.0016 19.7917C14.5938 19.7917 10.21 15.4078 10.21 10Z"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.8819 36.875H35.122C34.3092 30.1917 27.9769 24.7917 20.002 24.7917C12.0271 24.7917 5.69473 30.1917 4.8819 36.875ZM1.87695 38.3333C1.87695 29.1029 10.1401 21.875 20.002 21.875C29.8638 21.875 38.127 29.1029 38.127 38.3333V39.7917H1.87695V38.3333Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_31_627">
                    <rect
                        width="40"
                        height="40"
                        fill="white"
                        transform="matrix(-1 0 0 1 40 9.15527e-05)"
                    />
                </clipPath>
            </defs>
        </Icon>
    )
}

export default AccountIcon
